import { useParams, Link } from "react-router-dom";
import "../../../styles/single-project.css";

const SingleProjectPage = () => {
    const { id } = useParams();

    // Project data - in a real app this would come from an API/database
    const projectsData = {
        "im-academy": {
            title: "Mobile App for IM Academy",
            category: "Mobile App Development",
            year: "2024",
            client: "IM Academy",
            description: "A comprehensive mobile trading education platform with real-time market data and interactive learning modules. The app features live streaming capabilities, push notifications, and a sophisticated user dashboard.",
            challenge: "IM Academy needed a scalable mobile solution that could handle thousands of concurrent users while delivering real-time market data and video content seamlessly.",
            solution: "We built a cross-platform React Native application with a robust Node.js backend, utilizing AWS for scalable infrastructure and real-time data streaming.",
            results: ["50,000+ active users", "4.8 App Store rating", "99.9% uptime"],
            technologies: ["React Native", "Node.js", "AWS", "Redis", "PostgreSQL"],
            images: [
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/642363c47c68c82b957e2b6d_billboard-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg"
            ]
        },
        "real-rise": {
            title: "Customer Portal for Real Rise",
            category: "Web Application",
            year: "2024",
            client: "Real Rise",
            description: "A full-featured customer management portal with analytics dashboard, reporting tools, and automated workflows for streamlined business operations.",
            challenge: "Real Rise required a centralized platform to manage customer relationships, track performance metrics, and automate routine tasks.",
            solution: "We developed a modern React-based portal with Firebase backend, featuring real-time analytics, automated email workflows, and comprehensive reporting.",
            results: ["60% reduction in manual tasks", "3x faster customer response time", "200% increase in team productivity"],
            technologies: ["React", "Firebase", "Tailwind CSS", "Chart.js"],
            images: [
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423614f099312f269d37119_stationary-design-for-globex-thumbnail-image-darkstudio-x-webflow-template.jpg"
            ]
        },
        "4you-attorneys": {
            title: "Full Suite for 4you Attorneys",
            category: "Legal Tech Solution",
            year: "2023",
            client: "4you Attorneys",
            description: "Complete digital transformation including website, client portal, case management system, and document automation for a growing law firm.",
            challenge: "The firm was struggling with outdated systems, paper-based processes, and inefficient client communication methods.",
            solution: "We delivered an integrated suite of tools including a modern website, secure client portal, case tracking system, and automated document generation.",
            results: ["40% increase in client satisfaction", "75% reduction in paperwork", "2x more cases handled per attorney"],
            technologies: ["Next.js", "PostgreSQL", "Stripe", "DocuSign API"],
            images: [
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/642363c47c68c82b957e2b6d_billboard-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg"
            ]
        },
        "myaccidentexperts": {
            title: "Full Suite for MyAccidentExperts",
            category: "Legal Tech Solution",
            year: "2023",
            client: "MyAccidentExperts",
            description: "End-to-end legal tech solution with client intake forms, case tracking, and automated communication systems for personal injury law firm.",
            challenge: "Managing high volumes of personal injury cases with manual processes was causing delays and client dissatisfaction.",
            solution: "We created an automated intake system, case management dashboard, and client communication platform that streamlines the entire case lifecycle.",
            results: ["50% faster case resolution", "90% client satisfaction rate", "300+ cases managed monthly"],
            technologies: ["Vue.js", "Node.js", "MongoDB", "Twilio"],
            images: [
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423614f099312f269d37119_stationary-design-for-globex-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/642363c47c68c82b957e2b6d_billboard-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
                "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg"
            ]
        }
    };

    const project = projectsData[id];

    if (!project) {
        return (
            <div className="single-project-page">
                <div className="container-default w-container">
                    <div className="project-not-found">
                        <h1>Project Not Found</h1>
                        <p>The project you're looking for doesn't exist.</p>
                        <Link to="/projects" className="btn-secondary w-button">Back to Projects</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="single-project-page">
            {/* Hero Section */}
            <section className="project-hero">
                <div className="container-default w-container">
                    <Link to="/projects" className="project-back-link">
                        <span className="line-square-icon"></span>
                        Back to Projects
                    </Link>
                    <div className="project-hero-content">
                        <div className="project-meta">
                            <span className="project-category">{project.category}</span>
                            <span className="project-year">{project.year}</span>
                        </div>
                        <h1 className="display-2">{project.title}</h1>
                        <p className="project-hero-description">{project.description}</p>
                    </div>
                </div>
            </section>

            {/* Image Grid */}
            <section className="project-image-section">
                <div className="container-default w-container">
                    <div className="project-image-grid">
                        <div className="project-image-large">
                            <img 
                                src={project.images[0]} 
                                alt={`${project.title} - Main`}
                            />
                        </div>
                        <div className="project-image-stack">
                            <div className="project-image-small">
                                <img 
                                    src={project.images[1]} 
                                    alt={`${project.title} - Detail 1`}
                                />
                            </div>
                            <div className="project-image-small">
                                <img 
                                    src={project.images[2]} 
                                    alt={`${project.title} - Detail 2`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Details Section */}
            <section className="project-details-section">
                <div className="container-default w-container">
                    <div className="project-details-grid">
                        <div className="project-details-main">
                            <div className="project-detail-block">
                                <h3>The Challenge</h3>
                                <p>{project.challenge}</p>
                            </div>
                            <div className="project-detail-block">
                                <h3>Our Solution</h3>
                                <p>{project.solution}</p>
                            </div>
                        </div>
                        <div className="project-details-sidebar">
                            <div className="project-info-card">
                                <div className="project-info-item">
                                    <span className="project-info-label">Client</span>
                                    <span className="project-info-value">{project.client}</span>
                                </div>
                                <div className="project-info-item">
                                    <span className="project-info-label">Year</span>
                                    <span className="project-info-value">{project.year}</span>
                                </div>
                                <div className="project-info-item">
                                    <span className="project-info-label">Category</span>
                                    <span className="project-info-value">{project.category}</span>
                                </div>
                            </div>
                            <div className="project-tech-card">
                                <h4>Technologies Used</h4>
                                <div className="project-tech-tags">
                                    {project.technologies.map(tech => (
                                        <span key={tech} className="project-tech-tag">{tech}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Results Section */}
            <section className="project-results-section">
                <div className="container-default w-container">
                    <h2 className="display-3 text-center">Results</h2>
                    <div className="project-results-grid">
                        {project.results.map((result, index) => (
                            <div key={index} className="project-result-card">
                                <span className="project-result-text">{result}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="project-cta-section">
                <div className="container-default w-container">
                    <div className="project-cta-content">
                        <h2 className="display-3">Ready to start your project?</h2>
                        <p>Let's create something amazing together.</p>
                        <div className="project-cta-buttons">
                            <a href="/contact" className="btn-secondary w-button">Get in Touch</a>
                            <Link to="/projects" className="btn-secondary white w-button">View More Projects</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SingleProjectPage
